import {
    GET_ALL_SHARED_COLLECTION,
    SET_ALL_SHARED_COLLECTION,
    TOGGLE_COLLECTION_AS_FAVOURITE,
    TOGGLE_FAVOURITE_COLLECTION,
    GET_ALL_SHARED_COLLECTION_STYLE_WISE
} from '../../@types/thunk.types'
import { closeLoader, openLoader } from '../../Loader'
import {
    fetchCollectionStyeWise,
    fetchSharedCollection,
    likeSharedCollection
} from '../../../services/v3/SharedCollection/SharedCollection'
import { SharedCollectionActions } from './index'
import { toast } from 'react-toastify'

const SharedCollectionThunk = {
    [GET_ALL_SHARED_COLLECTION]: (params, requestBody) => async (dispatch) => {
        dispatch(openLoader())
        const data = await fetchSharedCollection(params, requestBody)
        dispatch(
            SharedCollectionActions[SET_ALL_SHARED_COLLECTION]({
                data,
                merge: data.currentPage > 0
            })
        )
        dispatch(closeLoader())
    },
    [GET_ALL_SHARED_COLLECTION_STYLE_WISE]:
        (params, requestBody) => async (dispatch) => {
            dispatch(openLoader())
            const data = await fetchCollectionStyeWise(params, requestBody)
            let productList = data.productResponsePage
            await dispatch(
                SharedCollectionActions[SET_ALL_SHARED_COLLECTION]({
                    collectionResponse: data.collectionResponseList,
                    data: productList,
                    merge: data.productResponsePage.currentPage > 0
                })
            )
            dispatch(closeLoader())
        },
    [TOGGLE_FAVOURITE_COLLECTION]:
        (bool, collectionId, folderId) => async (dispatch) => {
            dispatch(openLoader())
            const data = await likeSharedCollection(collectionId, folderId)
            toast.success(data.message)
            dispatch(
                SharedCollectionActions[TOGGLE_COLLECTION_AS_FAVOURITE](
                    collectionId
                )
            )
            dispatch(closeLoader())
        }
}

export default SharedCollectionThunk
